/**
 * The Admin route that renders the pre-session organization chooser.
 *
 * Kept in its own module so it can be unit-tested: the chooser is reached by a
 * full-page redirect from the OIDC callback and is matched against
 * `window.location.pathname` rather than through the router (which only mounts
 * once a session exists). A miss here silently falls through to the sign-in
 * screen and reproduces the multi-organization lockout this screen fixes.
 */
export const SELECT_ORG_PATH = '/select-org';

/**
 * Trailing-slash tolerant match. Depending on how the static host resolves the
 * route the browser can land on `/select-org` or `/select-org/`.
 */
export function isSelectOrgPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === SELECT_ORG_PATH;
}
